import React, {useEffect} from 'react';
import './PlanForm.css';
import { useSelector, useDispatch } from 'react-redux';
import { createPlannedItem, setColorCode, setStartTime, setEndTime, showPlanForm } from '../../store/PlannedItemStore';
import config from '../../config.json';
import Flatpickr from 'react-flatpickr';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultProfilePicture from '../../images/default_profile_picture_datadisplay.jpg';

const PlanForm = ({ personId }) => {
    const dispatch = useDispatch();
    
    const person = useSelector((state) => state.personState.persons[personId]);
    const colorCodes = useSelector((state) => state.plannedItemState.colorCodes.length > 0
        && state.plannedItemState.colorCodes.filter(x => !x.isAdminOnly));
    const visible = useSelector((state) => state.plannedItemState.showPlanForm);
    const plan = useSelector((state) => state.plannedItemState.plan);
    const endValid = useSelector((state) => state.plannedItemState.plan.endValid);
    const startValid = useSelector((state) => state.plannedItemState.plan.startValid);
    const doubleBook = useSelector((state) => state.plannedItemState.doubleBook);
    const valid = startValid && endValid;

    const submitForm = e =>{
        e.preventDefault();
        if(valid){
            dispatch(
                createPlannedItem({
                    personId: person.id,
                    colorCodeId: plan.colorCode || (colorCodes.length > 0 && colorCodes[0].id),
                    startTime: plan.startTime,
                    endTime: plan.endTime,
                })
            );
        }
    };

    const renderPerson = p =>{
        if(!p) return null;
        return(
            <div className="plan-profile">
                <div className="profile-text">
                    <h3>{p.name}</h3>
                    <p>{p.title}</p>
                 </div>
                 <img src={p.imagePath ? config.server + p.imagePath : defaultProfilePicture} alt="profile"/>
                 <div className="line"/>
            </div>
        )
    };

    useEffect(() => {
        if (colorCodes && colorCodes.length > 0) {
            const colorCode = colorCodes.find(x => String(x.id) === String(plan.colorCode));
            if (!colorCode) {
                dispatch(setColorCode(colorCodes[0].id));
            }
        }
    }, [colorCodes, plan.colorCode]);

    const ColorCodes = () => {

        return colorCodes && colorCodes.map(cc => {
            return <option key={cc.id} value={cc.id} style={{color: cc.hexColor}}>{cc.name}</option>
        });
    };

    return(
        <div className='PlanForm'>
            <div className={visible ? '' : ' hidden'}>
               {renderPerson(person)}
                <form>
                    <input name="person" type="hidden" />
                    <div className="form-group dropdown">
                        <select onChange={(e) => dispatch(setColorCode(e.target.value))} value={plan.colorCode || ''}>
                            {ColorCodes()}
                        </select>
                    </div>
                    <div className="form-group date">
                        <label>Start</label>
                        <Flatpickr
                            options={{time_24hr: true, enableTime: true, minuteIncrement: 15}}
                            onChange={(d) => dispatch(setStartTime(d[0].toISOString()))}
                            value={moment(plan.startTime).format('YYYY-MM-DD HH:mm')}
                            className={'date-picker-custom' + (startValid ? '' : ' invalid')}
                        />
                    </div>
                    <div className="form-group date">
                        <label>Slut</label>
                        <Flatpickr
                            options={{time_24hr: true, enableTime: true, minuteIncrement: 15}}
                            onChange={(d) => dispatch(setEndTime(d[0].toISOString()))}
                            value={moment(plan.endTime).format('YYYY-MM-DD HH:mm')}
                            className={'date-picker-custom' + (endValid ? '' : ' invalid')}
                        />
                    </div>
                    {doubleBook &&
                        <div className='error'>Denne tidsperiode, eller dele af denne tidsperiode er desværre allerede booket.</div>
                    }
                    <button className="submit" onClick={submitForm}>Send</button>
                </form>
            </div>
            <div className={visible ? 'hidden' : ''}>
                <div className="plan-more" onClick={() => dispatch(showPlanForm(true))}>Planlæg mere, tryk her</div>
            </div>
        </div>
    );
}

PlanForm.propTypes = {
    personid: PropTypes.string.isRequired
};

export default PlanForm;